import { useQuery } from '@tanstack/react-query';

import { currentAccountService } from '../services/currentAccount.service';

export const useJurisdictions = () => {
  return useQuery({
    queryKey: ['jurisdictions'],
    queryFn: () => currentAccountService.getJurisdictions()
  });
};
